/*
 * Ryan O'Dowd
 * 2024-03-02
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors, globalScale, fonts}) => {
  const title = {
    fontFamily: fonts.primaryBold,
    fontSize: globalScale * 18,
    color: colors.accent,
    marginBottom: 0,
  };

  const lightBackground = {
    color: colors.accentDark,
  };

  return {
    subtitle: {
      display: 'flex',
      color: colors.white,
      marginBottom: 16,
    },
    title,
    lightBackground,
    lightBackgroundText: {
      color: colors.dialogText,
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    sideBySide: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: 16,
    },
    section: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      minWidth: globalScale * 250,
    },
    bulletPoint: {
      display: 'flex',
      marginBottom: 16,
      flexDirection: 'column',
    },
    contactHeader: {
      ...title,
      ...lightBackground,
    },
    contactText: {
      display: 'inline',
      fontSize: globalScale * 14,
      marginTop: 0,
    },
    contactWrapper: { // @TODO: abstract with LandingPage
      minWidth: '50%',
      flex: 1,
    },
    downloadCtaWrapper: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
};

export default getStyles;
